/** Marketing site (Lovable). Chat, login, /api and /prod stay on this host. */
export const MARKETING_ORIGIN = "https://fam.life";

export const marketingUrl = (pathWithSearch = "/"): string => {
  const path = pathWithSearch.startsWith("/") ? pathWithSearch : `/${pathWithSearch}`;
  return `${MARKETING_ORIGIN}${path}`;
};
